// TestimonialsSection.js
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './TestimonialSection.css';

const TestimonialSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="section-testimonials padding-tb-50">
      <div className="container">
        <div className="row container">
          <div className="col-12" data-aos="fade-up" data-aos-duration="1000">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img
                  src="img/banner/left-shape.svg"
                  alt="banner-left-shape"
                  className="svg-img left-side"
                />
                Testimonials
                <img
                  src="img/banner/right-shape.svg"
                  alt="banner-right-shape"
                  className="svg-img right-side"
                />
              </p>
              <h4>
                Testimonial for <span> Om Sai PG </span>
              </h4>
            </div>
          </div>

          <div className="col-12 testi-section" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
            <Slider {...settings} className="rx-testimonials-slider">
              {/* Testimonial 1 */}
              <div className="testimonial-item">
                <div className="rx-testimonials-img">
                  <img
                    src="img/testimonials/boy1.jpg"
                    alt="testimonials-1"
                  />
                </div>
                <div className="rx-testimonials-contact">
                  <div className="rx-inner-banner">
                    <h4>Mr.Rajesh Kumar</h4>
                  
                  </div>
                  <div className="inner-contact">
                    <p>
                    "Staying at Om Sai PG was an absolute delight! The rooms were comfortable and well-maintained, and the staff was incredibly friendly and helpful. The facilities, including the Wi-Fi and meals, made it a perfect place to stay while I was away from home. Highly recommend!"
                    </p>
                  </div>
                </div>
              </div>

              {/* Testimonial 2 */}
              <div className="testimonial-item">
                <div className="rx-testimonials-img">
                  <img
                    src="img/testimonials/girl1.jpg"
                    alt="testimonials-2"
                  />
                </div>
                <div className="rx-testimonials-contact">
                  <div className="rx-inner-banner">
                    <h4>Mrs.Ritika S.</h4>
                    
                  </div>
                  <div className="inner-contact">
                    <p>
                    "I had the best stay at Om Sai PG! The ambiance was cozy and welcoming, and the food was delicious. I felt like I was staying in a home away from home. The management was always ready to assist, making it a hassle-free stay. Will definitely come back!"
                    </p>
                  </div>
                </div>
              </div>

              {/* Testimonial 3 */}
              <div className="testimonial-item">
                <div className="rx-testimonials-img">
                  <img
                    src="img/testimonials/boy2.jpg"
                    alt="testimonials-3"
                  />
                </div>
                <div className="rx-testimonials-contact">
                  <div className="rx-inner-banner">
                    <h4>Mr.Amit K.</h4>
                  
                  </div>
                  <div className="inner-contact">
                    <p>
                    "Om Sai PG exceeded my expectations! The rooms were spacious and clean, and the location was perfect—close to local markets and transport. I was impressed with the level of care they put into providing a comfortable experience for guests. Truly a wonderful place to stay!"
                    </p>
                  </div>
                </div>
              </div>


              {/* Testimonial 3 */}
              <div className="testimonial-item">
                <div className="rx-testimonials-img">
                  <img
                    src="img/testimonials/girl4.jpg"
                    alt="testimonials-3"
                  />
                </div>
                <div className="rx-testimonials-contact">
                  <div className="rx-inner-banner">
                    <h4>Mrs.Simran P.</h4>
                    
                  </div>
                  <div className="inner-contact">
                    <p>
                    "Om Sai PG is hands down the best PG I’ve stayed at! The facilities are exceptional, and the entire staff goes above and beyond to ensure a pleasant stay. The environment is peaceful, and it’s an ideal place for students and professionals alike. I wouldn’t hesitate to recommend it!"
                    </p>
                  </div>
                </div>
              </div>

              {/* Testimonial 3 */}
              <div className="testimonial-item">
                <div className="rx-testimonials-img">
                  <img
                    src="img/testimonials/boy4.jpg"
                    alt="testimonials-3"
                  />
                </div>
                <div className="rx-testimonials-contact">
                  <div className="rx-inner-banner">
                    <h4>Mr.Ravi Iyer</h4>
                   
                  </div>
                  <div className="inner-contact">
                    <p>
                    "I’ve stayed at many PGs, but Om Sai PG truly stands out. The cleanliness, the facilities, and the hospitality were all beyond my expectations. It was a stress-free experience, and I felt completely at home. I’ll definitely be choosing Om Sai PG again during my next visit."
                    </p>
                  </div>
                </div>
              </div>


              {/* Testimonial 3 */}
              <div className="testimonial-item">
                <div className="rx-testimonials-img">
                  <img
                    src="img/testimonials/boy3.jpg"
                    alt="testimonials-3"
                  />
                </div>
                <div className="rx-testimonials-contact">
                  <div className="rx-inner-banner">
                    <h4>Mr.Sandeep R.</h4>
              
                  </div>
                  <div className="inner-contact">
                    <p>
                    "What I loved most about Om Sai PG is the warm, homely atmosphere. The management is very professional yet personal, ensuring every guest feels comfortable. The food is tasty, and the rooms are comfortable. Perfect for both short and long stays!"
                    </p>
                  </div>
                </div>
              </div>

     
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
